<div id="infra">
  <div class="container-fluid">
      <div class="row">
          <div class="col-12">
              <div class="card shadow-lg inner-card">
                  <h4 class="card-title text-center">School Counselor</h4>
                  <div class="card-body">
                    <p class="inner-lead">Welcome to our school's Counseling Services! Our school counselor is a trained and experienced professional who provides a range of support services to help students achieve their full potential. Our counselor works closely with students, families, and staff to promote positive mental health and emotional well-being.
                    </p>  
                    <p class="inner-lead">At our school, we understand that academic success is not the only measure of a student's growth and development. That's why we have a dedicated counseling service to support our students in their personal, social, and emotional development.
                    </p>
                    <p class="inner-lead">At our school, we believe that counseling services are an essential component of our commitment to providing a safe and supportive learning environment for all students. We are proud to offer these services to our students and are committed to ensuring that they have access to the resources and support they need to achieve their full potential.
                    </p>
                  </div>
              </div>

          </div>
      </div>

     
  </div>
</div>